import it from './it'
import Utils from '../Utils'

var itMsg = {
  'agreements.title': 'Accordi',
  'agreements.error.mandatory': "È necessario accettare per continuare a utilizzare i servizi Deeper",
  'agreements.error.blank': "Ti preghiamo di prendere una decisione",
  'agreements.back': 'Indietro',
  'agreements.agree': 'Accetto',
  'agreements.decline': 'Rifiuto',
  'agreements.text.full': 'Intero accordo'
}

Utils.addTerms(itMsg, it)

export default itMsg



// WEBPACK FOOTER //
// ./src/lang/itMsg.js